/*=========================================================================================
File Name: state.js
Description: Vuex Store - state
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
let userDefaults = {
    givenName: 'John Doe',
    displayName: 'John Doe',
    roleId: 0,
    userRole: 'NULL',
    photoURL: require('@/assets/images/portrait/small/avatar-s-11.jpg'),
    status: 0,
    permissions: []
};

// State
// /////////////////////////////////////////////
let data = JSON.parse(localStorage.getItem('userData'));
let localStorageUserInfo = (data) ? data.user : null;

if (localStorageUserInfo) {
    userDefaults = {};
    userDefaults['givenName'] = localStorageUserInfo.given_name;
    userDefaults['displayName'] = localStorageUserInfo.full_name;
    userDefaults['roleId'] = localStorageUserInfo.acl.role.id;
    userDefaults['userRole'] = localStorageUserInfo.acl.role.name;
    userDefaults['photoURL'] = localStorageUserInfo.profile_pic;
    userDefaults['status'] = localStorageUserInfo.status;
    userDefaults['permissions'] = localStorageUserInfo.acl.permissions;
}
// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function (query) {
        return window.matchMedia(query).matches;
    }

    if (('ontouchstart' in window) || window.DocumentTouch) {
        return true;
    }

    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser: userDefaults,
    bodyOverlay: false,
    isVerticalNavMenuActive: true,
    is_touch_device: is_touch_device(),
    mainLayoutType: themeConfig.mainLayoutType || 'vertical',
    navbarSearchAndPinList: navbarSearchAndPinList,
    reduceButton: themeConfig.sidebarCollapsed,
    verticalNavMenuWidth: 'reduced',
    verticalNavMenuItemsMin: false,
    scrollY: 0,
    starredPages: navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
    theme: themeConfig.theme || 'light',
    themePrimaryColor: colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,


    // ////////////////////////////////////////////
    // CUSTOM VARIABLES
    // ////////////////////////////////////////////

    // Takedown Data
    takedownDomains: [],

    // Notifications
    notifications: [],

    // Roles
    roles: [
        {
            id: 1,
            name: 'GUEST'
        },
        {
            id: 2,
            name: 'ADMIN'
        }
    ],

    // Permissions Master
    permissionsMaster: [],

    // Categories Master
    categoriesMaster: [],

    // Keywords Master
    keywordsMaster: [],

    // Prefixes Master
    prefixesMaster: [],

    // Suffixes Master
    suffixesMaster: [],

    // Curated Names Master
    curatedNamesMaster: [],

    // Curated Tags Master
    curatedTagsMaster: [],
};

export default state
